import {
  useGetCmisProcessingProgressQuery,
  useGetCmisServicesQuery,
  useGetCustomerRequestHistoryQuery,
  useGetFieldTaskListQuery,
  useGetObstacleTicketQuery,
  useGetOptionDetailQuery,
  useGetOrganizationUnitChildrenQuery,
  useGetOrganizationUnitDetailServicesQuery,
  useGetPendingTicketQuery,
  useGetReasonOutageQuery,
  useGetTicketCountQuery,
  useGetTicketDetailQuery,
  useGetTicketListQuery,
  useGetUserInOrganizationUnitQuery
} from 'services';
import { CmisServicesRequestData, RequestData, TicketCountRequest } from 'types';
import defaultTicketDetail from '../../types/dto/request-form/request-form.dto';

// GET Tickets based on statuss
export function GetPendingTicket(pageSize: number) {
  const {
    data: customerRes,
    isLoading,
    refetch
  } = useGetPendingTicketQuery(pageSize!, {
    skip: !pageSize,
    refetchOnMountOrArgChange: true
  });

  return {
    pending: customerRes?.data.rows || [],
    pendingCount: Number(customerRes?.data.count),
    refetch: refetch ?? (() => {}),
    isLoading
  };
}

export function GetObstacleTicket(requestData: RequestData) {
  const {
    data: obstacleList,
    isLoading,
    refetch
  } = useGetObstacleTicketQuery(requestData!, {
    skip: !requestData,
    refetchOnMountOrArgChange: true
  });

  return {
    obstacle: obstacleList?.data.rows || [],
    obstacleCount: Number(obstacleList?.data.count),
    refetch: refetch ?? (() => {}),
    isLoading
  };
}

//Ticket Detail
export function GetTicketDetail(ticketId: number) {
  const {
    data: customerRes,
    isLoading,
    refetch
  } = useGetTicketDetailQuery(ticketId, {
    skip: !ticketId,
    refetchOnMountOrArgChange: true
  });

  return {
    requestDetail: customerRes?.data ?? defaultTicketDetail,
    refetch: refetch ?? (() => {}),
    isLoading
  };
}

/*** GET Tickets List */
export function GetTicketCount(ticketCountRequest: TicketCountRequest) {
  const {
    data: res,
    isLoading,
    refetch
  } = useGetTicketCountQuery(ticketCountRequest!, {
    skip: !ticketCountRequest,
    refetchOnMountOrArgChange: true
  });

  return {
    count: res?.data || 0,
    refetch: refetch ?? (() => {}),
    isLoading
  };
}

export function GetTicketList(requestData: RequestData) {
  const {
    data: customerRes,
    isLoading,
    refetch
  } = useGetTicketListQuery(requestData!, {
    skip: !requestData,
    refetchOnMountOrArgChange: true
  });

  return {
    data: customerRes?.data.rows || [],
    dataCount: Number(customerRes?.data.count || 0),
    refetch: refetch ?? (() => {}),
    isLoading
  };
}

export function GetOrganizationUnitChildren(organizationUnitId: number) {
  const { data: organizationUnitChildrenList, isLoading } = useGetOrganizationUnitChildrenQuery(organizationUnitId!, {
    skip: !organizationUnitId,
    refetchOnMountOrArgChange: true
  });

  return {
    data: organizationUnitChildrenList?.data.rows || [],
    isLoading
  };
}

export function GetOrganizationUnitDetailServicesQuery(organizationUnitId: number) {
  const { data: organizationUnitChildrenDetail, isLoading } = useGetOrganizationUnitDetailServicesQuery(
    organizationUnitId!,
    {
      skip: !organizationUnitId,
      refetchOnMountOrArgChange: true
    }
  );

  return {
    data: organizationUnitChildrenDetail?.data.rows || [],
    isLoading
  };
}

export function GetOptionDetailQuery(optionTypeId: number) {
  const { data: optionList, isLoading } = useGetOptionDetailQuery(optionTypeId!, {
    skip: !optionTypeId,
    refetchOnMountOrArgChange: true
  });

  return {
    data: optionList?.data.rows || [],
    serviceCount: optionList?.data.count,
    isLoading
  };
}

export function GetCmisService(requestData: CmisServicesRequestData) {
  const { data: optionList, isLoading } = useGetCmisServicesQuery(requestData!, {
    skip: !requestData,
    refetchOnMountOrArgChange: true
  });

  return {
    cmisServiceCount: optionList?.data.count,
    cmisData: optionList?.data.rows || [],
    isLoading
  };
}

export function GetUserListInOrganization(organizationUnitId: number) {
  const { data: userInOrganizationUnit, isLoading } = useGetUserInOrganizationUnitQuery(organizationUnitId!, {
    skip: !organizationUnitId,
    refetchOnMountOrArgChange: true
  });

  return {
    userInUnitCount: userInOrganizationUnit?.data.count,
    userInUnitList: userInOrganizationUnit?.data.rows || [],
    isLoading
  };
}

export function GetReasonOutageService(optionTypeId: number) {
  const { data: options, isLoading } = useGetReasonOutageQuery(optionTypeId!, {
    skip: !optionTypeId,
    refetchOnMountOrArgChange: true
  });

  return {
    optionsCount: options?.data.count,
    optionsList: options?.data.rows || [],
    optionLoading: isLoading
  };
}

export function GetCustomerRequestHistoryQuery(customerCode: string) {
  const { data: customerRequestHistory, isLoading } = useGetCustomerRequestHistoryQuery(customerCode!, {
    skip: !customerCode,
    refetchOnMountOrArgChange: true
  });

  return {
    customerRequestHistory: customerRequestHistory?.data || [],
    isLoading
  };
}

export function GetCmisProcessingProgress(requestCode: string) {
  const { data: cmisProcessingProgress, isLoading } = useGetCmisProcessingProgressQuery(requestCode!, {
    skip: !requestCode,
    refetchOnMountOrArgChange: true
  });

  return {
    cmisProcessingProgress: cmisProcessingProgress?.data || [],
    isLoading
  };
}

export function GetFieldTaskList(teamCode: string) {
  const {
    data: FieldTaskList,
    isLoading,
    refetch
  } = useGetFieldTaskListQuery(teamCode!, {
    skip: !teamCode,
    refetchOnMountOrArgChange: true
  });

  return {
    state: FieldTaskList?.data.state,
    fieldTaskList: FieldTaskList?.data.data || [],
    refetch: refetch ?? (() => {}),
    isLoading
  };
}
